/**
 * ProductPurchase DTO - one purchase in a product's purchase history.
 */
export class ProductPurchase {
  constructor(data = {}) {
    this.id = data.id || null;
    this.productId = data.productId || null;
    this.purchasedAt = data.purchasedAt || null;
    this.unitPrice = data.unitPrice !== undefined && data.unitPrice !== null ? Number(data.unitPrice) : null;
    this.supplier = data.supplier || null;
    this.reference = data.reference || null;
    this.notes = data.notes || null;
    this.source = data.source || 'MANUAL';
    this.createdAt = data.createdAt || null;
  }

  static fromJSON(json) {
    return json ? new ProductPurchase(json) : null;
  }
}

/**
 * CreateProductPurchaseRequest - payload to add a purchase. `purchasedAt` defaults to now on the server.
 */
export class CreateProductPurchaseRequest {
  constructor(data = {}) {
    this.purchasedAt = data.purchasedAt || null;
    this.unitPrice = data.unitPrice;
    this.supplier = data.supplier || null;
    this.reference = data.reference || null;
    this.notes = data.notes || null;
  }

  validate() {
    const errors = [];
    const price = Number(this.unitPrice);
    if (this.unitPrice === undefined || this.unitPrice === null || this.unitPrice === '' || Number.isNaN(price) || price < 0) {
      errors.push('Unit price must be a number greater than or equal to 0');
    }
    if (this.purchasedAt && new Date(this.purchasedAt).getTime() > Date.now()) {
      errors.push('Purchase date cannot be in the future');
    }
    return errors;
  }

  toJSON() {
    const json = { unitPrice: Number(this.unitPrice) };
    if (this.purchasedAt) json.purchasedAt = new Date(this.purchasedAt).toISOString();
    if (this.supplier) json.supplier = this.supplier;
    if (this.reference) json.reference = this.reference;
    if (this.notes) json.notes = this.notes;
    return json;
  }
}
